import rest from '../rest';
import contractFeeCount from './feesResponse';

const fees = [rest.get(`/api/v2/contracts/fees/count/:year/:types`, (req, res, ctx) => res(ctx.json(contractFeeCount)))];

export default fees;
